import { KYMW2400Model } from '../kymw2400.model';
import { PageTemplateModel } from '../vo/page-template.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * ページテンプレート更新コマンド。
 * 指定された情報（セクション情報）でテンプレート情報を更新する。
 *
 * @export UpdateTemplateService
 * @class UpdateTemplateService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateTemplateService extends PlessJsonResponderSub<any> {

  private model: KYMW2400Model = null;
  private vo: PageTemplateModel = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateTemplateService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      update: {
        PageTemplate: {
          condition: {
            PageTemplateID: this.vo.pageTemplateID
          },
          combination: this.vo.sectionList.map(sectionVO => {
            return {
              condition: {
                SectionTemplateID: sectionVO.sectionTemplateID,
                SectionTemplateName: sectionVO.sectionTemplateName,
                PositionX: sectionVO.percentPositionX,
                PositionY: sectionVO.percentPositionY,
                Width: sectionVO.percentWidth,
                Height: sectionVO.percentHeight,
                DivW: sectionVO.divW,
                DivH: sectionVO.divH
              }
            }
          })
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW2400Model} model モデルクラス
   * @param {PageTemplateModel} vo パラメータ
   * @memberof UpdateTemplateService
   */
  execute(model: KYMW2400Model, vo: PageTemplateModel) {
    this.model = model;
    this.vo = vo;

    this.send('updateTemplate', this.getBody());
    this.model.clearPageTemplateData();
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateTemplateService
   */
  success(data: any) {
    // テンプレートを更新しました。
    this.dialogService.openAlertGetMessage('I0106', ['テンプレートを更新']);
  }
}
